import { render, staticRenderFns } from "./Novel_List.vue?vue&type=template&id=f33297f0&scoped=true"
import script from "./Novel_List.vue?vue&type=script&lang=js"
export * from "./Novel_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33297f0",
  null
  
)

export default component.exports